import { forwardRef } from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import { HTMLKaajaProps } from '../../types';

type TextareaProps = HTMLKaajaProps<'textarea'>;

const Styled = styled('textarea')<TextareaProps>(
  (props) => ({
    width: '100%',
    padding: '14px 12px',
    fontSize: props.theme.fontSizes[1],
    color: props.theme.colors.neutral900,
    borderRadius: props.theme.radii.base,
    backgroundColor: props.theme.colors.white,
    border: `1px solid ${props.theme.colors.neutral300}`,
  }),
  space
);

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const { rows = 5, ...rest } = props;

    return <Styled ref={ref} rows={rows} {...rest} />;
  }
);

export { Textarea };
